import { render, staticRenderFns } from "./AlternativeEditorDialog.vue?vue&type=template&id=4568cc5e"
import script from "./AlternativeEditorDialog.vue?vue&type=script&lang=ts"
export * from "./AlternativeEditorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports